<template>
  <div>
    <!--筛选栏-->
    <div class="dateTab">
      <!-- 时间类型筛选 -->
      <select-single
        v-model="conditions.time_type"
        :width="30"
        text="月"
        optionStyle="yearlayer"
        :options="time_options"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量时间类型',
          businessCode: 3002,
          actionType: 'forecast-index-timetype-options',
        }"
      />
      <!--时间筛选-->
      <!-- :change="setDatePicker" -->
      <div class="section dateyear">
        <date-picker
          style="width: 182px"
          size="small"
          v-model="date_options"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始"
          end-placeholder="结束"
          :picker-options="pickerOptions"
          clearable
          v-track="{
            triggerType: 'click',
            currentUrl: $route.path,
            behavior: '产销量时间',
            businessCode: 3003,
            actionType: 'forecast-index-time-options',
          }"
        >
        </date-picker>
      </div>
      <!-- 派系筛选 -->
      <select-singles
        v-model="conditions.brand_origin"
        :width="40"
        text="派系"
        :options="options.origin_options"
        @reset="conditions_init('brand_origin')"
        :key="'brand_origin' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量派系',
          businessCode: 3007,
          actionType: 'forecast-index-origin-options',
        }"
      />
      <!--车型级别-->
      <select-categories
        v-model="conditions.body_size"
        text="车型级别"
        :categories="options.body_size_options"
        @reset="conditions_init('body_size')"
        :key="'body_size' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量车型级别',
          businessCode: 3004,
          actionType: 'forecast-index-bodysize-options',
        }"
      />
      <!-- 动力形式筛选 -->
      <select-singles
        v-model="conditions.propulsion_type"
        :width="60"
        text="动力形式"
        :options="options.propulsion_options"
        @reset="conditions_init('propulsion_type')"
        :key="'propulsion_type' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量动力形式',
          businessCode: 3005,
          actionType: 'forecast-index-propulsion-options',
        }"
      />
      <!--车企筛选-->
      <select-letters
        v-model="conditions.manufacturer"
        :width="40"
        position="right:-384px"
        text="车企"
        :options="options.manufacturer_options"
        @reset="conditions_init('manufacturer')"
        :key="'manufacturer' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量车企',
          businessCode: 3006,
          actionType: 'forecast-index-manufacturer-options',
        }"
      />
      <!--品牌筛选-->
      <select-letters
        v-model="conditions.brand"
        :width="40"
        position="right:-316px"
        text="品牌"
        :options="options.brand_options"
        @reset="conditions_init('brand')"
        :key="'brand' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量品牌',
          businessCode: 3008,
          actionType: 'forecast-index-brand-options',
        }"
      />
      <!--车系筛选-->
      <select-groups
        v-model="conditions.model"
        :width="40"
        position="right:-248px"
        text="车系"
        :options="options.model_options"
        @reset="conditions_init('model')"
        :key="'model' + component_key"
        v-track="{
          triggerType: 'click',
          currentUrl: $route.path,
          behavior: '产销量车系',
          businessCode: 30081,
          actionType: 'forecast-index-model-options',
        }"
      />
      <!--按钮-->
      <div class="selectBut">
        <a
          @click="filter"
          href="javascript:;"
          v-track="{
            triggerType: 'click',
            currentUrl: $route.path,
            behavior: '产销量查询按钮',
            businessCode: 3009,
            actionType: 'forecast-index-filter',
          }"
          >查询</a
        >
        <a @click="reset" href="javascript:" class="clear"
        v-track="{triggerType:'click',currentUrl: $route.path,behavior:'产销量清空按钮',businessCode: 3010, actionType:'forecast-index-reset'}">清空</a>
      </div>

      <!-- 面包屑 -->
      <bread-crumb
        v-model="breadcrumb_conditions"
        :options="options"
        @filter="filter"
        @deselect="deselect"
      />
    </div>
    <!--图表-->
    <div class="countChart">
      <div class="charTitle">
        <chart-title :words="title_data" separator="_" />
        <div class="chartIcon">
          <ul>
            <li :class="char_type === 'bar-yoy' ? 'chartcur' : ''">
              <a @click="bar_YOY()" href="javascript:;" class="cicon01">
                <div class="blackTips">柱状累计同比图</div>
              </a>
            </li>
            <li :class="char_type === 'bar-ratio' ? 'chartcur' : ''">
              <a @click="bar_ratio()" href="javascript:;" class="cicon02">
                <div class="blackTips">柱状堆积图</div>
              </a>
            </li>
            <li :class="char_type === 'line' ? 'chartcur' : ''">
              <a @click="line()" href="javascript:;" class="cicon03"
                ><div class="blackTips">曲线趋势图</div></a
              >
            </li>
            <li
              :class="char_type === 'line-compare' ? 'chartcur' : ''"
              v-if="is_show_compare"
            >
              <a
                @click="char_type = 'line-compare'"
                href="javascript:;"
                class="iconpercent"
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <bar-yoy
        :volume_data="volume_data"
        :width="960"
        :height="390"
        :time_type="conditions.time_type"
        :is_loading="is_loading"
        v-if="char_type === 'bar-yoy'"
      />
      <div style="height: 390px" v-if="char_type === 'bar-ratio'">
        <div style="float: left; position: absolute">
          <bar-ratio
            :volume_data="volume_data[1]"
            :width="480"
            :height="390"
            :barWidth="20"
            :barCategoryGap="16"
            :is_loading="is_loading"
            v-if="char_type === 'bar-ratio'"
          />
        </div>
        <div style="float: right; margin-left: 480px">
          <bar-ratio
            :volume_data="volume_data[0]"
            :width="480"
            :height="390"
            :barWidth="20"
            :barCategoryGap="16"
            :is_loading="is_loading"
            v-if="char_type === 'bar-ratio'"
          />
        </div>
      </div>
      <div style="height: 390px" v-if="char_type === 'line'">
        <lines
          :volume_data="volume_data"
          :time_type="conditions.time_type"
          :series_name="conditions.query_type === 'production' ? '产量' : '销量'"
          :width="960"
          :height="390"
          :is_loading="is_loading"
          v-if="char_type === 'line'"
        />
      </div>
      <!-- <lines-compare
        :volume_data="volume_data"
        :time_type="conditions.time_type"
        :width="960"
        :height="390"
        v-if="char_type === 'line-compare'"
      /> -->
    </div>
    <!--表格-->
    <div class="detailData">
      <div class="charTitle">
        <div class="title">所选详细数据</div>
        <download
          url="/excel/fullforecast"
          :params="{
            queryType: conditions.query_type,
            startYear: date_options[0].getFullYear(),
            startMonth: date_options[0].getMonth() + 1,
            endYear: date_options[1].getFullYear(),
            endMonth: date_options[1].getMonth() + 1,
            bodyType: JSON.stringify(conditions.body_size),
            manufacturerId: conditions.manufacturer.join(','),
            brandOriginId: conditions.brand_origin.join(','),
            brandId: conditions.brand.join(','),
            propulsionTypeId: conditions.propulsion_type.join(','),
            model: conditions.model.join(','),
          }"
          :words="title_data"
          separator="_"
        />
      </div>
      <div class="detailshow">
        <div class="dtDLeft onelineLeft">
          <div class="dataForm" :style="is_loading ? 'height:416px;' : ''">
            <transition name="loading">
              <loading v-show="is_loading" />
            </transition>
            <transition name="loading">
              <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                width="100%"
                v-show="!is_loading"
              >
                <tbody>
                  <tr>
                    <th>车企</th>
                    <th>派系</th>
                    <th>品牌</th>
                    <th>车系</th>
                    <th>车型</th>
                    <th>项目代号</th>
                    <th>平台</th>
                    <th>车身类型</th>
                    <th>大小级别</th>
                    <th>动力形式</th>
                    <th v-for="(time, index) in table_data.times" :key="index">
                      {{ time }}
                    </th>
                  </tr>
                  <tr v-for="(item, index) in table_data.result" :key="index">
                    <td>{{ item.vehicleManufacturer }}</td>
                    <td>{{ item.brandOriginName }}</td>
                    <td>{{ item.brandName }}</td>
                    <td>{{ item.modelName }}</td>
                    <td>{{ item.nameplate }}</td>
                    <td>{{ item.programCode }}</td>
                    <td>{{ item.platform }}</td>
                    <td>{{ item.bodyTypeName }}</td>
                    <td>{{ item.globalSizeName }}</td>
                    <td>{{ item.propulsionTypeName }}</td>
                    <td v-for="(volume, index) in item.volumes" :key="index">
                      {{ volume | num_format }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </transition>
          </div>
        </div>
        <div class="dtDRight onelineRight">
          <div class="dateEdit"></div>
        </div>
      </div>
      <pagination
        :page="page"
        @pagehandler="pageHandler"
        v-show="page.total > page.size"
      />
    </div>
    <!--提示-->
    <tips />
  </div>
</template>

<script>
import SelectSingle from "@/components/select/select-single";
import SelectSingles from "@/components/select/select-singles";
import SelectCategories from "@/components/select/select-categories";
import SelectLetters from "@/components/select/select-letters";
import SelectGroups from "@/components/select/select-groups";
import BreadCrumb from "@/components/breadcrumb";
import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Lines from "@/components/echarts/line-charts";
// import LinesCompare from "@/components/echarts/line-compare-charts";
import BarYoy from "@/components/echarts/bar-yoy-charts";
import BarRatio from "@/components/echarts/bar-ratio-charts";
import Tips from "@/components/tips";
import Loading from "@/components/loading";
import Pagination from "@/components/pagination";
import Download from "@/components/download";
import ChartTitle from "@/components/chart-title";

export default {
  name: "forecast",
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: "keywords",
          content: this.meta.keywords,
        },
        {
          name: "description",
          content: this.meta.description,
        },
      ],
    };
  },
  components: {
    SelectSingle,
    SelectSingles,
    SelectCategories,
    SelectLetters,
    SelectGroups,
    DatePicker,
    Lines,
    // LinesCompare,
    BarYoy,
    BarRatio,
    Tips,
    Loading,
    Pagination,
    Download,
    ChartTitle,
    BreadCrumb,
  },
  data() {
    return {
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
      date_options: [],
      time_options: [
        { text: "月", value: "month" },
        { text: "季", value: "quarter" },
        { text: "年", value: "year" },
      ],
      options: {
        propulsion_options: [],
        origin_options: [],
        body_size_options: [],
        manufacturer_options: [],
        brand_options: [],
        model_options: [],
      },
      breadcrumb_conditions: {},
      conditions: {
        query_type: "production",
        time_type: "month",
        body_size: [],
        propulsion_type: [],
        manufacturer: [],
        brand_origin: [],
        brand: [],
        model: [],
      },
      char_type: "bar-yoy",
      volume_data: [],
      table_data: [],
      title_data: [],
      page: {
        index: 1,
        size: 10,
        temp_index: 1,
        total: 0,
      },
      pickerOptions: {
        disabledDate: function (time) {
          var startdate = new Date("2015-12-31").getTime();
          var enddate = new Date("2028-12-31").getTime();
          return !(time.getTime() > startdate && time.getTime() < enddate);
        },
      },
      is_loading: true,
      is_show_compare: false,
      component_key: 0,
    };
  },
  watch: {
    $route(new_val) {
      if (new_val.params.query_type === "production") {
        this.conditions.query_type = "production";
        this.meta.title =
          "乘用车产销预测数据库_汽车产量数据查询年度累计/同期对比-盖亚系统";
        this.meta.keywords = "乘用车产销量预测数据,汽车产量数据查询";
        this.meta.description =
          "乘用车产销预测数据、汽车产量数据查询可以根据派系、车型级别、所属车企、品牌等查询到累计数据、同期对比值等乘用车产量相关数据。";
      } else {
        this.conditions.query_type = "sales";
        this.meta.title =
          "汽车销量数据查询_累计数据/同期对比-乘用车产销量预测数据库-盖亚系统	";
        this.meta.keywords = "汽车销量数据查询,乘用车产销量预测数据";
        this.meta.description =
          "乘用车产销量预测数据、汽车销量数据查询可根据派系、车型级别、车企、品牌等选项查询到所有乘用车销量年度累计数据、同期对比值等详细数据。";
      }
      this.conditions_init();
    },
  },
  created() {
    let date = new Date();
    date.setFullYear(this.$store.state.time_node.getFullYear());
    date.setMonth(this.$store.state.time_node.getMonth() - 11);
    this.date_options[0] = date;
    this.date_options[1] = this.$store.state.time_node;
    if (this.$route.params.query_type === "production") {
      this.conditions.query_type = "production";
      this.meta.title = "乘用车产销预测数据库_汽车产量数据查询年度累计/同期对比-盖亚系统";
      this.meta.keywords = "乘用车产销量预测数据,汽车产量数据查询";
      this.meta.description =
        "乘用车产销预测数据、汽车产量数据查询可以根据派系、车型级别、所属车企、品牌等查询到累计数据、同期对比值等乘用车产量相关数据。";
    } else {
      this.conditions.query_type = "sales";
      this.meta.title =
        "汽车销量数据查询_累计数据/同期对比-乘用车产销量预测数据库-盖亚系统	";
      this.meta.keywords = "汽车销量数据查询,乘用车产销量预测数据";
      this.meta.description =
        "乘用车产销量预测数据、汽车销量数据查询可根据派系、车型级别、车企、品牌等选项查询到所有乘用车销量年度累计数据、同期对比值等详细数据。";
    }
    this.conditions_init();
    // this.filter();
  },
  methods: {
    conditions_init(condition) {
      let _this = this;
      switch (condition) {
        case "brand_origin":
        case "body_size":
        case "propulsion_type":
          _this.conditions.manufacturer = [];
          _this.conditions.brand = [];
          _this.conditions.model = [];
          break;
        case "manufacturer":
          _this.conditions.brand = [];
          _this.conditions.model = [];
          break;
        case "brand":
          _this.conditions.model = [];
        // case 'model':
      }
      this.$http({
        url: "/forecast/condition",
        method: "get",
        crossdomain: true,
        params: {
          bodyType: JSON.stringify(_this.conditions.body_size),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          manufacturerId: _this.conditions.manufacturer.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          brandId: _this.conditions.brand.join(","),
        },
      })
        .then(function (res) {
          _this.options.body_size_options = res.data.bodyTypes;
          _this.options.propulsion_options = res.data.propulsionTypes;
          _this.options.origin_options = res.data.brandOrigins;
          _this.options.manufacturer_options = res.data.manufacturers;
          _this.options.brand_options = res.data.brands;
          _this.options.model_options = res.data.modelLines;

          _this.filter();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reset() {
      this.is_loading = true;
      this.page.index = 1;
      let date = new Date();
      document.getElementsByName("month")[0].click();
      date.setFullYear(this.$store.state.time_node.getFullYear());
      date.setMonth(this.$store.state.time_node.getMonth() - 11);
      this.date_options = [];
      this.$set(this.date_options, 0 , date)
      this.$set(this.date_options, 1 , this.$store.state.time_node)
      this.conditions.body_size = [];
      this.conditions.propulsion_type = [];
      this.conditions.manufacturer = [];
      this.conditions.brand_origin = [];
      this.conditions.brand = [];
      this.conditions.model = [];
      this.component_key += 1;
      this.conditions_init();
    },
    filter() {
      this.is_loading = true;
      if (this.char_type === "bar-yoy") {
        this.bar_YOY();
      }
      if (this.char_type === "bar-ratio") {
        this.bar_ratio();
      }
      if (this.char_type === "line") {
        this.line();
      }

      this.page.index = this.page.temp_index = 1;
      this.filter_table();
      this.title();
      this.breadcrumb_conditions = JSON.parse(JSON.stringify(this.conditions));
      // this.is_loading = true;
      // let _this = this;
      // this.$http({
      //   url: "/forecast/filter",
      //   method: "get",
      //   crossdomain: true,
      //   params: {
      //     queryType: _this.conditions.query_type,
      //     startYear: _this.date_options[0].getFullYear(),
      //     startMonth: _this.date_options[0].getMonth() + 1,
      //     endYear: _this.date_options[1].getFullYear(),
      //     endMonth: _this.date_options[1].getMonth() + 1,
      //     bodyType: JSON.stringify(_this.conditions.body_size),
      //     manufacturerId: _this.conditions.manufacturer.join(','),
      //     brandOriginId: _this.conditions.brand_origin.join(','),
      //     brandId: _this.conditions.brand.join(','),
      //     propulsionTypeId: _this.conditions.propulsion_type.join(','),
      //     model:_this.conditions.model.join(','),
      //     timeType: _this.conditions.time_type,
      //     chartType: _this.char_type,
      //     pageIndex: 1,
      //     pageSize: _this.page.page_size,
      //   },
      // })
      //   .then(function (res) {
      //     _this.volume_data = res.data;
      //     _this.volume_data.char_type = _this.char_type;
      //     _this.page.total = res.data.allCount;
      //     _this.page.index = _this.page.temp_index = 1;
      //     _this.is_loading = false;
      //     if ((_this.conditions.time_type === "quarter" &&!!_this.date_options &&_this.date_options[0].getMonth() == 0 &&_this.date_options[1].getMonth() == 11)
      //         ||_this.conditions.time_type == "year")
      //     {
      //       _this.is_show_compare = true;
      //     } else {
      //       _this.is_show_compare = false;
      //       // _this.char_type = "line";
      //     }
      //     _this.title();
      //     _this.breadcrumb_conditions = JSON.parse(JSON.stringify(_this.conditions));
      //   })
      //   .catch(function (error) {
      //     if (error.response == undefined) {
      //       return false;
      //     }
      //     let date = new Date();
      //     switch (error.response.status) {
      //       case 403:
      //         _this.is_loading = false;
      //         date.setFullYear(_this.$store.state.time_node.getFullYear());
      //         date.setMonth(_this.$store.state.time_node.getMonth() - 11);
      //         _this.date_options[0] = date;
      //         _this.date_options[1] = _this.$store.state.time_node;
      //         _this.page.index = 1;
      //         document.getElementsByName("month")[0].click();
      //         // _this.conditions.time_type = 'month';
      //         // _this.conditions.bodyType = 0;
      //         // _this.conditions.globalSize = 0;
      //         // _this.conditions.propulsionType = 0;
      //         // _this.conditions.manufacturer = 0;
      //         // _this.conditions.brandOrigin = 0;
      //         // _this.conditions.brand = 0;
      //         break;
      //     }
      //   });
    },
    bar_YOY() {
      this.char_type = "bar-yoy";
      let _this = this;
      this.$http({
        url: "/forecast/barYOY",
        method: "get",
        crossdomain: true,
        params: {
          queryType: _this.conditions.query_type,
          startYear: _this.date_options[0].getFullYear(),
          startMonth: _this.date_options[0].getMonth() + 1,
          endYear: _this.date_options[1].getFullYear(),
          endMonth: _this.date_options[1].getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          manufacturerId: _this.conditions.manufacturer.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          brandId: _this.conditions.brand.join(","),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          model: _this.conditions.model.join(","),
          timeType: _this.conditions.time_type,
        },
      })
        .then(function (res) {
          _this.volume_data = res.data;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          // let date = new Date();
          switch (error.response.status) {
            case 403:
              break;
          }
        });
    },
    bar_ratio() {
      this.char_type = "bar-ratio";
      let _this = this;
      this.$http({
        url: "/forecast/barRatio",
        method: "get",
        crossdomain: true,
        params: {
          queryType: _this.conditions.query_type,
          startYear: _this.date_options[0].getFullYear(),
          startMonth: _this.date_options[0].getMonth() + 1,
          endYear: _this.date_options[1].getFullYear(),
          endMonth: _this.date_options[1].getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          manufacturerId: _this.conditions.manufacturer.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          brandId: _this.conditions.brand.join(","),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          model: _this.conditions.model.join(","),
          timeType: _this.conditions.time_type,
        },
      })
        .then(function (res) {
          _this.volume_data = res.data;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          // let date = new Date();
          switch (error.response.status) {
            case 403:
              break;
          }
        });
    },
    line() {
      this.char_type = "line";
      let _this = this;
      this.$http({
        url: "/forecast/line",
        method: "get",
        crossdomain: true,
        params: {
          queryType: _this.conditions.query_type,
          startYear: _this.date_options[0].getFullYear(),
          startMonth: _this.date_options[0].getMonth() + 1,
          endYear: _this.date_options[1].getFullYear(),
          endMonth: _this.date_options[1].getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          manufacturerId: _this.conditions.manufacturer.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          brandId: _this.conditions.brand.join(","),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          model: _this.conditions.model.join(","),
          timeType: _this.conditions.time_type,
          chartType: _this.char_type,
        },
      })
        .then(function (res) {
          _this.volume_data = res.data;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          // let date = new Date();
          switch (error.response.status) {
            case 403:
              break;
          }
        });
    },
    filter_table() {
      // this.is_loading = true;
      let _this = this;
      this.$http({
        url: "/forecast/table",
        method: "get",
        crossdomain: true,
        params: {
          queryType: _this.conditions.query_type,
          startYear: _this.date_options[0].getFullYear(),
          startMonth: _this.date_options[0].getMonth() + 1,
          endYear: _this.date_options[1].getFullYear(),
          endMonth: _this.date_options[1].getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          manufacturerId: _this.conditions.manufacturer.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          brandId: _this.conditions.brand.join(","),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          model: _this.conditions.model.join(","),
          tableTimeType: _this.conditions.time_type,
          pageIndex: _this.page.temp_index,
          pageSize: _this.page.page_size,
        },
      })
        .then(function (res) {
          if (res.data == null) {
            return;
          }
          _this.table_data = res.data;
          _this.page.total = res.data.allCount;
          _this.page.index = _this.page.temp_index;
          _this.is_loading = false;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          let date = new Date();
          switch (error.response.status) {
            case 403:
              _this.is_loading = false;
              date.setFullYear(_this.$store.state.time_node.getFullYear());
              date.setMonth(_this.$store.state.time_node.getMonth() - 11);
              _this.date_options[0] = date;
              _this.date_options[1] = _this.$store.state.time_node;
              break;
          }
        });
    },
    title() {
      let _this = this;
      this.title_data = [];
      if (this.date_options[0].getFullYear() === this.date_options[1].getFullYear()) {
        this.title_data.push(
          _this.date_options[0].getFullYear() +
            "-" +
            (_this.date_options[0].getMonth() + 1)
        );
        this.title_data.push();
      } else {
        this.title_data.push(
          _this.date_options[0].getFullYear() +
            "-" +
            (_this.date_options[0].getMonth() + 1) +
            "至" +
            _this.date_options[1].getFullYear() +
            "-" +
            (_this.date_options[1].getMonth() + 1)
        );
      }
      // this.title_data.push(_this.conditions.brand_origin !== 0 ? _this.origin_options.filter(t => t.brandOriginId === _this.conditions.brand_origin)[0].brandOriginName : '');
      // if(_this.conditions.body_size.body_type !== 0 && _this.conditions.body_size.global_size !== 0)
      // {
      //   let global_sizes = _this.body_size_options.filter(t => t.bodyTypeId === _this.conditions.body_size.body_type)[0].globalSizes
      //   this.title_data.push(_this.conditions.body_size.global_size !== 0 ? global_sizes.filter(t => t.globalSizeId === _this.conditions.body_size.global_size)[0].globalSizeName : '');
      //   this.title_data.push(_this.conditions.body_size.body_type !== 0 ? _this.body_size_options.filter(t => t.bodyTypeId === _this.conditions.body_size.body_type)[0].bodyTypeName : '');
      // }
      //  this.title_data.push(_this.conditions.propulsion_type !== 0 ? _this.propulsion_options.filter(t => t.propulsionTypeId === _this.conditions.propulsion_type)[0].propulsionTypeName : '');
      // this.title_data.push(_this.conditions.manufacturer !== 0 ? _this.manufacturer_options.filter(t => t.manufacturerId === _this.conditions.manufacturer)[0].vehicleManufacturer : '');
      // this.title_data.push(_this.conditions.brand !== 0 ? _this.brand_options.filter(t => t.brandId === _this.conditions.brand)[0].brandName : '');
      this.title_data.push(
        (_this.conditions.query_type === "production" ? "产量" : "销量") +
          "所选条件下数据概览"
      );
    },
    pageHandler: function (page) {
      this.page.temp_index = page;
      this.filter_table();
    },
    setDatePicker: function (e) {
      if (!!e && !!this.date_options) {
        if (this.conditions.time_type == "quarter") {
          this.$set(
            this.date_options,
            0,
            new Date(
              e[0].getFullYear() + "-" + (Math.ceil((e[0].getMonth() + 1) / 3) * 3 - 2)
            )
          );
          this.$set(
            this.date_options,
            1,
            new Date(e[1].getFullYear() + "-" + Math.ceil((e[1].getMonth() + 1) / 3) * 3)
          );
        } else if (this.conditions.time_type == "year") {
          this.$set(this.date_options, 0, new Date(e[0].getFullYear() + "-01"));
          this.$set(this.date_options, 1, new Date(e[1].getFullYear() + "-12"));
        }
      }
    },
    deselect(condition_type, choiced_value, attach) {
      switch (condition_type) {
        case "brand_origin":
          this.conditions.brand_origin.splice(
            this.conditions.brand_origin.indexOf(choiced_value),
            1
          );
          break;
        case "propulsion_type":
          this.conditions.propulsion_type.splice(
            this.conditions.propulsion_type.indexOf(choiced_value),
            1
          );
          break;
        case "manufacturer":
          this.conditions.manufacturer.splice(
            this.conditions.manufacturer.indexOf(choiced_value),
            1
          );
          break;
        case "brand":
          this.conditions.brand.splice(this.conditions.brand.indexOf(choiced_value), 1);
          break;
        case "body_size":
          this.conditions.body_size.splice(
            this.conditions.body_size.indexOf(
              this.conditions.body_size.find((t) => t.body_type === choiced_value)
            ),
            1
          );
          break;
        case "global_size":
          if (
            this.conditions.body_size.find((t) => t.body_type === choiced_value)
              .global_size.length === 1
          ) {
            this.conditions.body_size.splice(
              this.conditions.body_size.indexOf(
                this.conditions.body_size.find((t) => t.body_type === choiced_value)
              ),
              1
            );
          } else {
            this.conditions.body_size
              .find((t) => t.body_type === choiced_value)
              .global_size.splice(
                this.conditions.body_size
                  .find((t) => t.body_type === choiced_value)
                  .global_size.indexOf(attach),
                1
              );
          }
          break;
        case "model":
          this.conditions.model.splice(this.conditions.model.indexOf(choiced_value), 1);
          break;
      }
    },
  },
};
</script>
